/* 
 * Javascript for umem.org forms.
 * 
 * Uses the jQuery Datepicker for all date inputs.
 */

import 'jquery-ui-dist/jquery-ui';
// I don't know why this has to be local but at least this works
import './jquery.timepicker.js';
import fileUpload from 'blueimp-file-upload/js/jquery.fileupload.js';

$(function(){

	// Setup date and time pickers
	$('input.time').timepicker({ 'timeFormat': 'h:i a' });

	// Setup button toggles
	$('button.button-toggle').on('click', function () {
		var $this = $(this);
		var $input = $('#' + $this.attr('id') + '_input');

		$this.button('toggle');

		if($this.hasClass('active')){
			$this.button('enabled');
			$input.prop('checked', true);
		}else{
			$this.button('disabled');
			$input.prop('checked', false);
		}
	})

	// Logic for Adding statuses 
	$(window).on('add.mopa-collection-item', function (event, full_collection, added_item) {
		$('input.time').timepicker({ 'timeFormat': 'h:i a' });
	})

});



// WEBPACK FOOTER //
// ./AppBundle/Resources/assets/js/include/form.js